<div class="seperator"></div>
<div class="title" mat-dialog-title>Connect Shopify Store</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">Please login to your shopify store and install rubii from app store: 
            <a href="https://apps.shopify.com/rubii" class="shopify-app-store-href" target="_blank" data-cy="shopify-datasources-link">https://apps.shopify.com/rubii</a>
        </div>
    </div>
</div>
<div class="dialog-footer">
    <div>
    </div>
</div>